import React from "react";
import type { FC, JSX, PropsWithChildren } from "react";

import { createDisplayNameForButtonCellElement } from "../../utils/getDisplayName";
import { createTestIdForButtonCellElement } from "../../utils/getTestId";

import classes from "./ButtonCellRightAddon.styl";

const RIGHT_ADDON_TEST_ID = createTestIdForButtonCellElement("right-addon");

interface IButtonCellRightAddon {}

export const ButtonCellRightAddon: FC<
    PropsWithChildren<IButtonCellRightAddon>
> = ({ children }): JSX.Element => {
    return (
        <div className={classes["right-addon"]} data-tsid={RIGHT_ADDON_TEST_ID}>
            {children}
        </div>
    );
};

ButtonCellRightAddon.displayName =
    createDisplayNameForButtonCellElement("RightAddon");

export default ButtonCellRightAddon;
